import UntitledIcon from '@payaca/untitled-icons';
import { FunctionComponent, type JSX } from 'react';
import './ImageBlock.sass';

type Props = {
  imageSrc?: string;
  renderBlockIfNoImageSrc?: boolean;
};

const ImageBlock: FunctionComponent<Props> = ({
  imageSrc,
  renderBlockIfNoImageSrc = true,
}: Props): JSX.Element | null => {
  if (!renderBlockIfNoImageSrc && !imageSrc) return null;
  return (
    <div className="image-block">
      {!imageSrc && <UntitledIcon name="image-01.3" />}
      {imageSrc && <img src={imageSrc} />}
    </div>
  );
};

export default ImageBlock;
